import directorPhoto from '../images/sneha-h-director-new.jpeg';

function Director() {
  const qualifications = [
    'Diploma in Acupuncture, Bharathiar University, Tamil Nadu',
    'International Yoga Trainer, Yoga Darshanam, Mysuru',
    'Diploma in Electrical Engineering, Board of Technical Education, Karnataka',
    'Master Trainer in Abacus, Vedic Mathematics, Handwriting and Calligraphy',
  ];

  const achievements = [
    { number: '23+', label: 'Years of experience' },
    { number: '500+', label: 'Teachers trained' },
    { number: '8,000+', label: 'Abacus & Vedic Maths students' },
    { number: '5,000+', label: 'Workshop participants' },
  ];

  return (
    <section className="director" id="director">
      <div className="container">
        <div className="section-title director-heading">
          <span className="eyebrow">Leadership</span>
          <h2>Meet Our Director</h2>
          <p>Experienced educationist, trainer and mentor shaping confident learners.</p>
        </div>

        <article className="director-card">
          <div className="director-photo-wrap">
            <img
              className="director-photo"
              src={directorPhoto}
              alt="Ms. Sneha H., Director of The Bright Future Organisation"
            />
          </div>

          <div className="director-details">
            <p className="director-label">Director</p>
            <h3>Ms. Sneha H.</h3>
            <p className="director-designation">
              Director, The Bright Future Organisation
            </p>
            <p className="director-bio">
              Ms. Sneha H. brings 23 years of experience as an educationist,
              trainer and mentor. She has trained students, teachers and
              education professionals across Telangana, Andhra Pradesh,
              Karnataka and Tamil Nadu through skill-based learning programs.
            </p>
            <p className="director-bio">
              She formerly served as Director of Amazing Abacus Learning Centre
              (2005–2012) and Genius Brains Educare India Pvt. Ltd. (2012–2018).
            </p>

            <h4>Qualifications</h4>
            <ul className="director-qualifications">
              {qualifications.map((qualification) => (
                <li key={qualification}>{qualification}</li>
              ))}
            </ul>
          </div>
        </article>

        <div className="director-stats" aria-label="Director achievements">
          {achievements.map((achievement) => (
            <div className="director-stat" key={achievement.label}>
              <strong>{achievement.number}</strong>
              <span>{achievement.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Director;
